<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 title="Exportação COHAB"
                 command="view" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" go-back-to="custom-consorciocohab9-checklist-cohab"
                 :busy="!pageFormIsLoaded">

      <template #default>

        <t-form-card title="Dados da Inspeção" class="mt-2">

          <b-row>

            <t-input v-model="form.checklistNumber"
                     lpad="4"
                     cols="4"
                     label="Cód. Inspeção"
                     fixed
                     highlight/>

            <t-input cols="4" v-model="form.otherCodeLabel" highlight fixed label="Cód. Interno"/>

            <t-input cols="4" v-model="form.typeChecklist" fixed label="Modelo de Inspeção"/>

          </b-row>

          <t-input v-model="form.enterprise" fixed label="Empreendimento"/>

          <b-row>

            <t-input cols="3" v-model="form.enterpriseZipcode" fixed label="CEP"/>

            <t-input cols="9" v-model="form.enterpriseAddressFull" fixed label="Endereço"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.enterpriseNeighborhood" fixed label="Bairro"/>

            <t-input cols="6" v-model="form.enterpriseCityFull" fixed label="Cidade - UF"/>

          </b-row>

          <b-button
              :to="{path: '/checklist/'+form.checklistNumber}"
              class="mt-2"
              variant="outline-primary" target="_blank">
            <b-icon-box-arrow-up-right class="mr-2"/>
            Detalhar Inspeção de Origem
          </b-button>

        </t-form-card>

        <t-form-card title="Informações Exportação" class="mt-2">

          <b-row>

            <t-input cols="6" fixed v-model="form.issueDate" date label="Data Inspeção"/>

            <t-input cols="6" fixed v-model="form.checklistStatusLastChangeDate" datetime label="Data Exportação"/>

          </b-row>

          <div v-if="form.checklistStatusLastChangeDate === undefined">

            <b-button
                :href="'https://custom.onlaine.com.br/integration/custom/consorciocohab9/cohab.asp?install=Y&token='+token+'&checklistId='+form.checklistId"
                variant="primary" target="_blank">
              <b-icon-box-arrow-up-right class="mr-2"/>
              Acessar Módulo Exportação
            </b-button>

<!--
           Desabilita, pois quando marca manualmente por aqui não finaliza versão.
           <t-button class="ml-3" secondary @click="transmitirSPObras">
              Marcar manualmente como transmitido
            </t-button>

            -->

          </div>

          <div v-else>

            <b-row>

              <t-input cols="4" fixed v-model="form.integrationCurrentRevision" label="Revisão Atual"/>

              <t-input cols="4" fixed v-model="form.integrationCurrentRevisionDateFinished" datetime label="Data Revisão"/>

              <t-input cols="4" fixed v-model="form.integrationCurrentRevisionUser" label="Responsável"/>

            </b-row>

            <b-button
                class="mr-2"
                :href="'https://custom.onlaine.com.br/integration/custom/consorciocohab9/cohab_ajax.asp?token='+token+'&checklistId='+form.checklistId+'&t=DRG'"
                variant="primary" target="_blank">
              <b-icon-file-pdf/>
              Download Relatório
            </b-button>





            <t-button @click="estornarExportacao">Estornar Exportação</t-button>

          </div>

        </t-form-card>

        <t-form-card title="Relatórios de Atividades" class="mt-2" v-if="activities.length > 0">

          <b-row class="mb-2">

            <b-button
                :to="{path:'/'+activity.path}"
                v-for="activity in activities" :key="activity.checklistActivityId"
                variant="outline-primary" class="mr-2" target="_blank">
              <b-icon-box-arrow-up-right class="mr-2"/>
              {{ activity.name }}
            </b-button>

          </b-row>


        </t-form-card>


        <t-form-card :title="item.division + ' - ' + item.environment" class="mb-3"
                     v-for="item in environments.filter(a => a.finishDate !== undefined && a.qtyEvidenceFile > 0)"
                     :key="item.checklistEnvironmentId">


          <ChecklistEnvironmentEvidenceFile type-image
                                            :business-evidence-file-required-fields="form.businessEvidenceFileRequiredFields"
                                            :foreign-key="item.checklistEnvironmentId"/>

        </t-form-card>




      </template>



    </t-page-form>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ChecklistEnvironmentEvidenceFile from "@/views/modules/checklist/Checklist/ChecklistEnvironmentEvidenceFile";
import ui from "@/assets/scripts/ui";
import ChecklistModelActivityService from "@/services/modules/checklist/ChecklistModelActivity.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ConsorcioCohab9Form',
  components: {ChecklistEnvironmentEvidenceFile},
  data() {
    return {
      path: "checklist", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "checklistId",
      enableGeneralFields: false,
      form: {},
      activities: [],
      environments: [],
      error: {//Campos que podem receber retorno de erro do backend

      },
      token: "",
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      environmentsFields: [
        {key: "environment", label: "Ambiente"},
        /*        {key: "field_706", label: "Último Avanço %", formatter: "number"},
                {key: "field_707", label: "Avanço Físico %", formatter: "number"},*/
      ]
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },

    async mountedContinued() {

      const account = await this.$store.getters.getAccountUser

      this.token = account.token

      await crudGeneral.getAll('checklist/environment', 1, 'checklistId=' + this.form.checklistId)
          .then(response => {

            this.environments = response.data

            for (let item of this.environments) {

              if (!this.objValid(item.finishDate)) {
                item.class = 'bg-light'
              }

            }

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          });

      await ChecklistModelActivityService.getList(this.form.checklistId)
          .then((list) => this.activities = list)
          .catch(error => this.responseError(error))



      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async transmitirSPObras() {

      ui.msgConfirm(this, 'Confirmação', 'Tem certeza que deseja marcar a inspeção como exportada manualmente para COHAB?', async () => {

        const checklistStatusUpdate = {
          checklistId: this.form.checklistId,
          checklistStatusId: 13, /*Enviado Cohab*/
          note: "",
          clearLastChangeDate: false,
        }

        await crudGeneral.update(this.path + "/updateStatus", checklistStatusUpdate).then(
            () => {
              ui.toast(this, "Informação", "Exportação marcada com sucesso!")
              this.setRedirect('custom/checklist/cohab', this.form.checklistId, 'view', 0, "", true)
            }
        ).catch(error => this.responseError(error))

      })


    },
    async estornarExportacao() {

      ui.msgConfirm(this, 'Confirmação', 'Tem certeza que deseja estornar a inspeção como exportada para COHAB?', async () => {

        const checklistStatusUpdate = {
          checklistId: this.form.checklistId,
          checklistStatusId: 12, /*Pendente Cohab 9*/
          note: "",
          clearLastChangeDate: true,
        }

        await crudGeneral.update(this.path + "/updateStatus", checklistStatusUpdate).then(
            () => {
              ui.toast(this, "Informação", "Transmissão desmarcada com sucesso!")
              ui.reload()
            }
        ).catch(error => this.responseError(error))

      })


    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>